import { useEffect, useState } from "react";
import Navbar from "../components/landing/Navbar";
import Hero from "../components/landing/Hero";
import Stats from "../components/landing/Stats";
import Services from "../components/landing/Services";
import WhyUs from "../components/landing/WhyUs";
import ApplyForm from "../components/landing/ApplyForm";
import Publishers from "../components/landing/Publishers";
import FaqSection from "../components/landing/FaqSection";
import Contact, { Footer, WhatsAppFloat } from "../components/landing/Contact";
import api from "../lib/api";

export default function Landing() {
  const [settings, setSettings] = useState(null);
  const [publishers, setPublishers] = useState([]);
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
    api.get("/publishers").then((r) => setPublishers(r.data)).catch(() => {});
    api.get("/faqs").then((r) => setFaqs(r.data)).catch(() => {});
    if (!sessionStorage.getItem("hoom_tracked")) {
      sessionStorage.setItem("hoom_tracked", "1");
      api.post("/track", { path: window.location.pathname }).catch(() => {});
    }
  }, []);

  return (
    <div data-testid="landing-page" className="bg-[#050505] text-white">
      <Navbar settings={settings} />
      <Hero />
      <Stats settings={settings} />
      <Services />
      <WhyUs />
      <ApplyForm />
      <Publishers publishers={publishers} />
      <FaqSection faqs={faqs} />
      <Contact settings={settings} />
      <Footer settings={settings} />
      <WhatsAppFloat settings={settings} />
    </div>
  );
}
